// DELEGATE — the referral-link write moved to `@heidi/evidence`; the two app
// reactions stayed.
//
// It is a T2 delegate rather than a `meta` shim, on both legs independently:
//
//   * `invalidateCurrentUser()` is WORKSPACE's command and composite (`GET_USER`
//     plus the commerce `GET_PRODUCTS` behind one try/catch). The owning domain
//     exports it and app integration sequences it — the call stays here rather
//     than being injected into the package, which would hide an edge the
//     manifest cannot see.
//   * the error toast SUBSTITUTES the backend detail for its fallback
//     description (`get(error.response, 'data.detail.msg', <fallback>)`) where
//     `appendBackendDetail` on a `meta` toast would concatenate the two. That is
//     a different string on the same failure, so the copy and its i18next lookup
//     stay here.
//
// The exported signature is unchanged — no arguments, same return — so every
// call site and every `jest.mock('@/hooks/mutation/useMutateEvidenceReferralLink')`
// literal keeps resolving; the options object is an internal detail of the ports.
import { toast } from '@heidi/design-system/toast';
import { useMutateEvidenceReferralLink as useMutateEvidenceReferralLinkCore } from '@heidi/evidence/data';
import { useTranslations } from '@heidi/runtime/i18n';
import { get } from 'lodash-es';
import { invalidateCurrentUser } from '../query/useQueryUser';

/**
 * Hook to generate or retrieve the user's Evidence referral link.
 *
 * @returns Mutation result with the referral link
 */
export function useMutateEvidenceReferralLink() {
  const { t } = useTranslations();

  return useMutateEvidenceReferralLinkCore({
    onReferralLinkGenerated: async () => {
      await invalidateCurrentUser();
    },
    onGenerateReferralLinkError: (error) => {
      toast({
        tone: 'destructive',
        title: t('evidenceReferral.generateErrorTitle'),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        description: get(
          error.response,
          'data.detail.msg',
          t('evidenceReferral.generateErrorDescription')
        ),
      });
    },
  });
}
